export default __webpack_public_path__ + "static/media/qrcode-circle-fill.74f47d3e.svg";